import { Box } from "@mui/material";
import { SmartForm, useSmartForm } from "@nodeon/react-components";
import React from "react";
import CoordinateSystemAutocomplete from "~/pages/marine-survey-and-design-page/dialogs/CoordinateSystemAutocomplete";
import { ProjectEpsgAutoFillType } from "./ProjectUploadContent";
import { SetProjectionType } from "./UploadedFilesContainer";

export type ProjectEpsgAutoFillProps = {
  setProjectionId: SetProjectionType;
  projectionId: number | null;
};

export const ProjectEpsgAutoFill = ({
  setProjectionId,
  projectionId,
}: ProjectEpsgAutoFillProps) => {
  const defaultValues = React.useMemo(
    () => ({
      coordinateSystemId: projectionId ?? null,
    }),
    [projectionId],
  );

  const formMethods = useSmartForm<ProjectEpsgAutoFillType>({
    defaultValues,
  });
  const { coordinateSystemId } = formMethods.watch();

  React.useEffect(() => {
    setProjectionId(coordinateSystemId);
  }, [coordinateSystemId, setProjectionId]);

  return (
    <SmartForm<ProjectEpsgAutoFillType>
      methods={formMethods}
      onSubmit={() => {}}
      noGrid
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "auto min-content",
          flexBasis: " 100%",
        }}
      >
        <CoordinateSystemAutocomplete<ProjectEpsgAutoFillType>
          name="coordinateSystemId"
          formMethods={formMethods}
          required
        />
      </Box>
    </SmartForm>
  );
};
